<template>
   <!-- StartOF ログイン -->
        <div class="bg">
            <div class="center-content">
                <!-- 会社のロゴ -->
                <img src="@/assets/site_img/logo.png" alt="logo photo" class="logo">
                <!-- ログインフォーム -->
                <form class="form col-md-8 col-lg-9 col-xl-12" @submit.prevent="add_login_data">
                    <div v-if="alertVisible" class="alert alert-warning">
                        {{ alertMessage }}
                    </div>
                    <div v-if="unauthorizedMessage" class="alert alert-danger">
                        {{ unauthorizedMessage }}
                    </div>
                    <div v-if="sessionExpiredMessage" class="alert alert-warning">
                        <p>{{ sessionExpiredMessage }}</p>
                    </div>
                    <div class="form-input">
                        <input type="text" v-model="userData.uid" placeholder="USER ID or EMAIL"
                        class="form-control input-text" @focus="inputFocus = true" @blur="inputFocus = false" required>
                        <span class="icon"><i class="bi bi-person" :style="{ color: inputFocus ? 'black' : 'white' }"></i></span>
                    </div>
                    <div class="form-input">
                        <input type="password" v-model="userData.password" placeholder="PASSWORD"
                        class="form-control input-text" @focus="inputPasswordFocus = true" @blur="inputPasswordFocus = false" autocomplete="password" required :minlength="5" :maxlength="10">
                        <span class="icon"><i class="bi bi-lock"  :style="{ color: inputPasswordFocus ? 'black' : 'white' }"></i></span>
                    </div>
                    <div class="form-input mt-4">
                        <button class="btn btn-lg btn-light w-100 fs-5 login-btn">Login</button>
                    </div>
                </form>
                <!-- パスワードを再設定する -->
            </div>
        </div>
    <!-- EndOF ログイン -->
</template>
<style lang="css" scoped src="@/assets/css/login.css"></style>
<script>
import { mapState } from 'vuex';
import Configuration from "../Service/configuration.js";
import DataService from "../Service/data-service.js";
import { msg_code } from "@/Util/msg_code.js";

export default {
    data() {
        return {
            queryMessage: this.$route.query.message || '',
            userData: {},
            userList: [],
            inputFocus: false,
            inputPasswordFocus: false,
            uid: "",
            password: "",
            alertVisible: false,
            alertMessage: "",
        };
    },
    computed: {
        ...mapState({
            unauthorizedMessage: (state) => state.auth.unauthorizedMessage,
            sessionExpiredMessage: (state) => state.sessionExpiredMessage,
        }),
    },

    methods: {
        //入力を検証する
        validateForm() {
            let errorText = "";
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (this.userData.uid.includes('@')) {
                if (!emailPattern.test(this.userData.uid)) {
                    errorText += msg_code("wf006");
                }
                else{
                    errorText += null;
                    return true;
                }
            } else if (!Number.isInteger(Number(this.userData.uid)) || /^\s+|\s+$/.test(this.userData.uid)) {
                errorText += msg_code("wf005");
            }
            if (errorText) {
                this.showAlert(errorText);
                return false; // Validation failed
            }
            return true; // Validation passed
        },
        // ログインを実行する
        async add_login_data() {
            if (!this.validateForm()) {
                return;
            }
            var dataService = new DataService();
            var config = new Configuration();
            try {
                const response = await dataService.callWithPostWithoutToken(config.SERVICE_NAME_LOGIN, this.userData);
                if (response.success === true) {
                    this.alertVisible = false;
                    localStorage.setItem('isAuthenticated', true);
                    localStorage.setItem('token', response.token);
                    localStorage.setItem('logoutFlag', false);
                    localStorage.setItem('userID', response.user.uid);
                    localStorage.setItem('userEmail', response.user.email);
                    localStorage.setItem('role', response.user.role);
                    this.$store.commit('setUnauthorizedMessage', '');
                    this.$store.commit('setUserEmail', response.user.email);
                    this.$store.commit('setUserID', response.user.uid);
                    this.$store.commit('setToken', response.token);
                    this.$store.commit('setRole', response.user.role);
                    this.$store.commit('setPermission', response.permission);
                    const permission = JSON.stringify(response.permission);
                    localStorage.setItem('permission', permission);
                    await this.loginUser(response.token, response.user.uid, response.user.email);
                    this.$router.push("/applicantList");
                    //ログインが成功した場合、応募者一覧に移動する
                }
                else if(response.error === true){
                    this.showAlert(response.message);
                    this.$store.commit('setAuthenticated', false);
                    localStorage.setItem('isAuthenticated', false);
                }
            }
            catch (error) {
                this.showAlert(error.message);
            }
        },
        // エラーメッセージを表示する
        showAlert(message) {
            if (this.sessionExpiredMessage) {
            this.$store.dispatch('setSessionExpiredMessage', '');
           }
            this.alertMessage = message;
            this.alertVisible = true;
        },

        loginUser(token, uid, email) {
            this.$store.dispatch('login', {
                token: token,
                userID: uid,
                userEmail: email,
            });
        }
    },
};
</script>